import React, { Suspense } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Lazy Load Pages for Performance (Code Splitting)
const Home = React.lazy(() => import('./pages/Home'));
const HowItWorks = React.lazy(() => import('./pages/HowItWorks'));
const SupportedApps = React.lazy(() => import('./pages/SupportedApps'));
const AppDetail = React.lazy(() => import('./pages/AppDetail'));
const PricingPage = React.lazy(() => import('./pages/PricingPage'));
const Contact = React.lazy(() => import('./pages/Contact'));
const Technology = React.lazy(() => import('./pages/Technology'));
const FAQ = React.lazy(() => import('./pages/FAQ'));
const Privacy = React.lazy(() => import('./pages/Privacy'));
const Terms = React.lazy(() => import('./pages/Terms'));
const Consultation = React.lazy(() => import('./pages/Consultation'));

// Loading Fallback Component
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-brand-dark">
    <div className="w-12 h-12 border-4 border-orange-200 border-t-brand-primary rounded-full animate-spin"></div>
  </div>
);

// Scroll to top wrapper
const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-brand-dark text-slate-900 font-sans selection:bg-brand-primary selection:text-white flex flex-col relative overflow-hidden">
        
        {/* Animated Background Layer */}
        <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" aria-hidden="true">
             <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-orange-200/40 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob"></div>
             <div className="absolute top-0 right-1/4 w-[500px] h-[500px] bg-purple-200/40 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob animation-delay-2000"></div>
             <div className="absolute -bottom-32 left-1/3 w-[600px] h-[600px] bg-pink-200/40 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob animation-delay-4000"></div>
             <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-blue-100/40 rounded-full mix-blend-multiply filter blur-3xl opacity-70"></div>
        </div>

        <Navbar />
        
        <main className="flex-grow relative z-10">
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/cara-kerja" element={<HowItWorks />} />
              <Route path="/aplikasi-didukung" element={<SupportedApps />} />
              <Route path="/aplikasi/:slug" element={<AppDetail />} />
              <Route path="/harga" element={<PricingPage />} />
              <Route path="/hubungi-kami" element={<Contact />} />
              <Route path="/teknologi" element={<Technology />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/privasi" element={<Privacy />} />
              <Route path="/syarat" element={<Terms />} />
              <Route path="/konsultasi" element={<Consultation />} />
              {/* Fallback */}
              <Route path="*" element={<Home />} />
            </Routes>
          </Suspense>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
};

export default App;